import React, { Component } from "react";
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal'
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import IconButton from '@material-ui/core/IconButton';
import { Button } from "@material-ui/core";

import {
    GetDevicesSorted,
    AddDevice,
    GetDevice,
    UpdDevice,
    UnregisterResidents,
    UnregisterResidentsFilter,
    GetDevicesLocations,
    GetDevicesResidents,
    GetDevicesSerials,
    AddMessageChangeStatus
} from '../../actions/deviceActions';
import { GetIcons } from '../../actions/categoryActions'

//FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faClipboardList,
    faGlobe,
    faSort,
    faSortAlphaDown,
    faSortAlphaUpAlt
} from "@fortawesome/free-solid-svg-icons";

import { currentScrollingPage } from "../../constants/index";

//3 party Libs
import moment from 'moment';
import LModalMessage from './LModalMessage';
import DeviceFiltersDrawer from "../../views/community/DeviceFiltersDrawer";


export class MessagingList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModalUntegister: false,
            showModalMessage: false,
            showModalReboot: false,
            isRegister: false,
            isUpdDevice: false,
            selectedDevices: [],
            openSearch: false,
            selectAllButton: false,
            searchValue: '',
            devices: this.props.tableData ? this.props.tableData : [],
            currentPage: currentScrollingPage,
            filterObj: undefined,
            openFilters: false,
            AnchorElId: undefined,
            community: props.communityInfo,
            //Sorting
            sortColumn: 'lowerName',
            sortDesc: true
        };

        this.observer = React.createRef();
        this.lastDeviceRef = node => {
            /* FUNCION CALL BACK */
            if (this.observer.current) this.observer.current.disconnect();
            this.observer.current = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) {
                    this.setState((prevState) => ({ currentPage: prevState.currentPage + 1 }), async () => {
                        const resp = await this.props.GetDevicesSorted(localStorage.getItem('communityId'), this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);

                        if (this.state.selectAllButton && resp)
                            this.SelectAllDevicesActive(resp);
                    });
                }
            });
            if (node) this.observer.current.observe(node)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.communityInfo) {
            let communityId = this.state.community ? this.state.community._id : undefined;
            if (communityId === undefined || communityId !== nextProps.communityInfo._id) {
                this.setState(
                    {
                        community: nextProps.communityInfo,
                        filterObj: undefined,
                        selectedDevices: [],
                        selectAllButton: false,
                        openFilters: false,
                        AnchorElId: undefined
                    }, () => {
                        this.props.GetDevicesSorted(nextProps.communityInfo.communityId, 0, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
                    }
                );
            }
        }
    }

    componentDidMount() {
        const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;
        this.props.GetDevicesSorted(communityId, this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
        this.props.GetIcons();
    }

    OnCancelHandler = () => {
        this.setState({ showModalUntegister: false, showModalMessage: false, showModalReboot: false });
    };

    OnUnregisterHandler = () => {
        const newMessage = {}
        newMessage.notificationType = "Full"
        newMessage.notificationType = "Unregistration"
        newMessage.messageType = "Normal"

        newMessage.topics = [];

        this.state.selectedDevices.forEach(selected => {
            newMessage.topics.push(`${selected.residentId}/${selected._id}`);
        });

        let messageDate = moment(new Date());

        newMessage.messageDate = messageDate;
        const stylesObj = { modalStyles: { backgroundColor: '#ffffff' }, messageClass: 'LAlertMessageStyles' };

        if (this.state.selectAllButton)
            this.props.UnregisterResidentsFilter(localStorage.getItem('communityId'), this.state.filterObj, newMessage, this.state.sortColumn, this.state.sortDesc, stylesObj);
        else
            this.props.UnregisterResidents(this.state.selectedDevices, localStorage.getItem('communityId'), newMessage, stylesObj);

    };

    //#region  Inner Components -Get status icons
    GetStatusIcons = ({ active = false, lastConnectionDate = undefined }) => {

        const now = new Date();
        const lastConn = lastConnectionDate ? new Date(lastConnectionDate) : undefined;

        const umbralInMinutes = this.props.umbralInMinutes ? this.props.umbralInMinutes : 5;
        let lastConnectionWithinUmbral = false;

        if (!lastConn || isNaN(lastConn.getTime())) {
            lastConnectionWithinUmbral = false;
        } else {
            lastConnectionWithinUmbral = (umbralInMinutes * 60 * 1000) > (now.getTime() - lastConn.getTime());
        }

        return (
            <Grid item container justify='center' alignContent='center'>
                <Grid item style={{ margin: '0 5px', marginRight: '35px' }}>
                    <FontAwesomeIcon
                        className="icon-menu-size"
                        icon={faClipboardList}
                        style={{ color: active ? '#5BDB86' : '#959494' }}
                    />
                </Grid>
                <Grid item style={{ margin: '0 5px' }}>
                    <FontAwesomeIcon
                        className="icon-menu-size"
                        icon={faGlobe}
                        style={{ color: lastConnectionWithinUmbral ? '#5BDB86' : '#959494' }}
                    />
                </Grid>
            </Grid>
        );
    }
    //#endregion

    handleDeleteClick = async (e, data, index) => {
        if (e) {
            e.stopPropagation();
        }

        this.setState({ showModalUntegister: true, isRegister: false, selectedDevices: [data] });

    };


    handleSelectDevice = (device) => {

        //Get the dinings already selected
        const arr = this.state.selectedDevices;

        //Know if the dining is already in the array
        const item = arr.find(item => item._id === device._id);

        let button = false

        //If its not we push the dining
        if (!item) {
            arr.push(device)

            if (arr.length === this.props.tableData.length) button = true

        }
        else { //If it is we remove it from the array
            const indexToDelete = arr.findIndex(object => (object._id === device._id));
            arr.splice(indexToDelete, 1);
        }

        this.setState({ selectedDevices: arr, selectAllButton: button });
        this.props.isSelectedDevices(arr);
    }

    handleSelectAll = (e) => {
        const selectAllButton = !this.state.selectAllButton;
        let selected = this.state.selectedDevices

        const allDevices = this.props.tableData ? this.props.tableData : [];

        if (allDevices.length > 0) {

            if (selectAllButton) {
                allDevices.forEach(item => {
                    const exist = this.state.selectedDevices.find(d => d._id === item._id);
                    (!exist) && selected.push(item);

                });
            }
            else {
                selected = [];
            }
        }

        this.setState({ selectedDevices: selected, selectAllButton: selectAllButton });
        this.props.isSelectedDevices(selected);
    };

    SelectAllDiningsOnScrolling = () => {
        const allDevices = this.props.tableData ? this.props.tableData : [];
        let selected = this.state.selectedDevices

        if (allDevices.length > 0) //First we add all the new data into the selected arr
            allDevices.forEach(item => {
                const exist = this.state.selectedDevices.find(d => d._id === item._id);

                (!exist) && selected.push(item);
            });

        //Now we filter because it could be dinings that migth not be in the new filtered data
        selected = selected.filter(d => {
            return allDevices.find(element => (element._id === d._id));
        })


        this.setState({ selectedDevices: selected });
    }

    onFilterChange = (filterObj) => {
        const community = localStorage.getItem('communityId');

        if (filterObj) {

            this.setState({
                filterObj: filterObj,
                currentPage: 0,
                selectedDevices: [],
                selectAllButton: false,
                openFilters: false,
                AnchorElId: undefined
            }, () => {
                this.props.GetDevicesSorted(community, this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);
            });
        }

    }

    handleSort = (column) => {

        const currentColumn = this.state.sortColumn;

        const updState = {
            sortColumn: currentColumn,
            sortDesc: this.state.sortDesc,
            currentPage: 0,
            filtersApplied: true
        }

        if (currentColumn !== column) {
            updState.sortColumn = column
            updState.sortDesc = true;
        } else {
            updState.sortDesc = !this.state.sortDesc
        }

        this.setState(updState, async () => {
            const resp = await this.props.GetDevicesSorted(localStorage.getItem('communityId'), this.state.currentPage, this.state.sortColumn, this.state.sortDesc, this.state.filterObj);

            if (this.state.selectAllButton) {
                this.SelectAllDevicesActive(resp)
            }

        })
    }

    SelectAllDevicesActive = (newData = []) => {
        let arrayDeviceSelected = this.state.selectedDevices ? this.state.selectedDevices : [];
        if (newData) {
            newData.forEach(item => {
                const indexOfItemAllReadySelected = (this.state.selectedDevices) ? this.state.selectedDevices.map(item => item._id).indexOf(item._id) : -1;

                if (indexOfItemAllReadySelected === -1) {

                    arrayDeviceSelected.push(item);
                }
            }
            );

            this.setState({ selectedDevices: arrayDeviceSelected })
        }
    }

    showMessageModal = () => {
        if (this.state.selectedDevices.length > 0)
            this.setState({ showModalMessage: true })
    }

    render() {

        const currentData = this.props.tableData && Array.isArray(this.props.tableData) ? this.props.tableData : [];

        const total = this.props.total ? this.props.total : 0;
        const displayHeaders = this.state.isMobile ? 'none' : 'flex';

        return (
            <>
                <div className="activityTitle-engage" style={{ width: '100%', padding: '35px' }}>
                    <form >
                        <div id="Message_Btn" style={{ display: 'none' }}
                            onClick={() => this.showMessageModal()
                            }>
                            Message
                        </div>
                        {
                            ///Device List
                            <Grid container className="activityTitle-engage">
                                {/* Selected All Button and selected item counter */}
                                <Grid item container xs={4} justifyContent='flex-start' alignItems='center'>
                                    <Button id='addEditDevice_Headers_SelectAll' className="LselectAllButton" onClick={() => this.handleSelectAll()}>
                                        Select All
                                    </Button>
                                    <span className="LselectAllQtyMessage" style={{ marginLeft: '16px' }}>
                                        {
                                            this.state.selectAllButton ?
                                                `${total} Selected` :
                                                this.state.selectedDevices.length > 0 ?
                                                    `${this.state.selectedDevices.length} Selected`
                                                    :
                                                    ''
                                        }
                                    </span>
                                </Grid>
                                {/* Search and filters menu */}
                                <Grid item container xs={8} justifyContent='flex-end' alignItems='center'>
                                    <IconButton item onClick={(e) => this.setState({ openFilters: true, AnchorElId: 'filters_btn' })} id='filters_btn'>
                                        <img
                                            src='https://engage360.s3.amazonaws.com/Icons/LegacyIcons/filter.svg'
                                            alt='filters_icon'
                                            width='30px'
                                            heigth='30px'
                                        />
                                    </IconButton>

                                </Grid>
                                <Grid container>
                                    <Grid container className='LGridColumnTitle' justifyContent='center' alignItems='center' style={{ flexGrow: 1, display: displayHeaders }} >
                                        <Grid item md={1} id='addEditDevice_Headers' style={{}} >
                                        </Grid>
                                        <Grid item md={5} style={{ alignItems: 'center', display: 'flex', justifyContent: 'left' }} id='addEditDevice_Headers_Resident'>
                                            Resident
                                            <IconButton onClick={() => this.handleSort('lowerName')}>
                                                <FontAwesomeIcon icon={(this.state.sortColumn === 'lowerName' && this.state.sortDesc) ? faSortAlphaDown : (this.state.sortColumn === 'lowerName' && !this.state.sortDesc) ? faSortAlphaUpAlt : (this.state.sortColumn !== 'lowerName') ? faSort : null} color='#a2a1a2' />
                                            </IconButton>
                                        </Grid>
                                        <Grid item md={6} style={{ alignItems: 'center', display: 'flex', justifyContent: 'left' }} id='addEditDevice_Headers_Location'>
                                            Location
                                            <IconButton onClick={() => this.handleSort('lowerLocation')}>
                                                <FontAwesomeIcon icon={(this.state.sortColumn === 'lowerLocation' && this.state.sortDesc) ? faSortAlphaDown : (this.state.sortColumn === 'lowerLocation' && !this.state.sortDesc) ? faSortAlphaUpAlt : (this.state.sortColumn !== 'lowerLocation') ? faSort : null} color='#a2a1a2' />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        {
                                            currentData.map((item, index) => {

                                                if (currentData.length === index + 1) { /* We call the reference in the last row */
                                                    return (
                                                        <Grid item container ref={this.lastDeviceRef} key={index} className='LDeviceCell' alignContent='center' style={{ backgroundColor: '#FAFAFA', padding: '5px', borderRadius: '4px', marginTop: '6px', textAlign: 'center' }}>
                                                            <Grid item container justify='center' alignContent='center' className='CheckboxBlue RepairsCell' xs={1}>
                                                                <Checkbox
                                                                    id={`device_checkbox_${item._id}`}
                                                                    checked={this.state.selectedDevices && this.state.selectedDevices.length > 0 ? this.state.selectedDevices.find(device => device._id === item._id) !== undefined ? true : false : false}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    onChange={() => this.handleSelectDevice(item)}
                                                                    icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                                                                    checkedIcon={
                                                                        <CheckBoxIcon fontSize="large" />
                                                                    }
                                                                />
                                                            </Grid>
                                                            <Grid item container className="LResidentCell" xs={12} sm={12} md={5} alignContent='center' style={{ alignItems: 'center', display: 'flex', justifyContent: 'left' }} >
                                                                <Grid item style={{ paddingLeft: '15px' }}>
                                                                    {item.residentName}
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item container className="LLocationCell" xs={12} sm={12} md={6} alignContent='center' justifyContent='left'>
                                                                <Grid item>
                                                                    {item.residentLocation}
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    )
                                                } else {
                                                    return (
                                                        <Grid item container key={index} className='LDeviceCell' alignContent='center' style={{ backgroundColor: '#FAFAFA', padding: '5px', borderRadius: '4px', marginTop: '6px', textAlign: 'center' }}>
                                                            <Grid item container justify='center' alignContent='center' className='CheckboxBlue RepairsCell' xs={1}>
                                                                <Checkbox
                                                                    id={`device_checkbox_${item._id}`}
                                                                    checked={this.state.selectedDevices && this.state.selectedDevices.length > 0 ? this.state.selectedDevices.find(device => device._id === item._id) !== undefined ? true : false : false}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    onChange={() => this.handleSelectDevice(item)}
                                                                    icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                                                                    checkedIcon={
                                                                        <CheckBoxIcon fontSize="large" />
                                                                    }
                                                                />
                                                            </Grid>
                                                            <Grid item container className="LResidentCell" xs={12} sm={12} md={5} alignContent='center' style={{ alignItems: 'center', display: 'flex', justifyContent: 'left' }} >
                                                                <Grid item style={{ paddingLeft: '15px' }}>
                                                                    {item.residentName}
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item container className="LLocationCell" xs={12} sm={12} md={6} alignContent='center' justifyContent='left'>
                                                                <Grid item>
                                                                    {item.residentLocation}
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    )
                                                }

                                            })
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        }

                    </form>

                    {/* MESSAGE MODAL */}
                    <Modal
                        open={this.state.showModalMessage}
                        onClose={() => this.setState({ showModalMessage: false })}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{ borderRadius: '16px' }}
                    >
                        <LModalMessage
                            OnCancelHandler={this.OnCancelHandler}
                            selectedDevices={this.state.selectedDevices}
                            selectAllButton={this.state.selectAllButton}
                            filterObj={this.state.filterObj}
                            sortColumn={this.state.sortColumn}
                            sortDesc={this.state.sortDesc}
                        />
                    </Modal>

                    {/* FILTERS MODAL */}
                    {
                        this.state.openFilters && this.state.AnchorElId ?
                            <DeviceFiltersDrawer
                                idAnchorEl={this.state.AnchorElId}
                                onClose={() => this.setState({ openFilters: false, AnchorElId: undefined })}
                                residents={this.props.residentsNames}
                                serialNumbers={this.props.serials}
                                zoneNames={this.props.locations}
                                onFilterChange={this.onFilterChange}
                                isLegacy={true}
                                isMessagingList={true}
                                filterObj={this.state.filterObj ? this.state.filterObj : {}}
                            />
                            :
                            undefined
                    }
                </div>
            </>
        )
    }

}

function mapStateToProps(state) {
    const deviceData = (state.deviceReducer && state.deviceReducer.deviceData) ? [...state.deviceReducer.deviceData] : [];
    const total = (state.deviceReducer && state.deviceReducer.totalDevices) ? state.deviceReducer.totalDevices : 0;

    const residentsNames = (state.deviceReducer && state.deviceReducer.residents) ? state.deviceReducer.residents : [];
    const locations = (state.deviceReducer && state.deviceReducer.locations) ? state.deviceReducer.locations : [];
    const serials = (state.deviceReducer && state.deviceReducer.serials) ? state.deviceReducer.serials : [];

    return {
        tableData: deviceData,
        total,
        deviceReducerType: (state.deviceReducer && state.deviceReducer.type) ? state.deviceReducer.type : "",
        serials,
        residentsNames,
        locations
    }
}


export default connect(mapStateToProps, { AddMessageChangeStatus, GetDevicesSorted, AddDevice, GetDevice, UpdDevice, UnregisterResidents, UnregisterResidentsFilter, GetDevicesLocations, GetDevicesResidents, GetDevicesSerials, GetIcons })(reduxForm({
    form: 'MessagingList',
    enableReinitialize: true
})(MessagingList));